import { AssetDto, AssetVersionDto } from '@picflow/types';

export const canDisplayAsset = (asset: AssetDto, versionData?: AssetVersionDto) => {
  if (!asset) return false;
  if (!versionData) versionData = asset.version_data;
  if (!versionData) return false;
  if (asset.type === 'video') {
    if (!versionData.data?.['poster_url']) return false;
    if (versionData['status'] === 'in_progress') return true;
  }
  if (versionData['status'] === 'completed') return true;
  return false;
};
